import React from "react";
import { useNavigate } from "react-router-dom";
import "../../src/styles/QuotaModal.css";

const QuotaModal = ({ isOpen }) => {
  console.log('Modal is open');  // Debug log

  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleDeny = () => {
    window.location.reload(); // Refresh the page
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Daily Quota Reached</h2>
        <p>
          You've reached your daily practice limit. To support the platform and continue practicing today, you can contribute and Unlock by clicking the 'Buy Me a Coffee' button below. Your small contribution helps us maintain the platform website and ensures you can keep practicing to succeed in your PTE exam.
        </p>
        <p>
          If you prefer to wait for tomorrow to continue practicing for free, simply click the "Wait Until Tomorrow" button.
        </p>
        <div className="modal-buttons">
          <a
            href="https://buymeacoffee.com/learningtutorial"
            target="_blank"
            rel="noopener noreferrer"
            className="buy-coffee-btn"
          >
            Buy Me a Coffee ☕
          </a>
          <button onClick={handleDeny} className="wait-btn">
            Wait Until Tomorrow
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotaModal;
